import React, { useEffect, useState } from "react";
import { SortArrow } from "../../svg/sort-arrow";
import CustomCheckBox from "../customCheckBox/customCheckBox";

interface TableHeaderProps {
  sortedTableHeaders: {
    key: string;
    label: string;
    width: number;
    sortable?: boolean;
    subKey?: string;
    type?: string;
  }[];
  tableWidth: number;
  onSortTableData: (key: string, subKey?: string, type?: string) => void;
  onSelectAll?: () => void;
  isCheckboxSelected?: boolean;
}

/**
 * Sticky header row for RisaCustomTable with optional sort affordances.
 *
 * @param props - Ordered headers and sort/select-all handlers
 * @returns Table header element
 */
const TableHeader: React.FC<TableHeaderProps> = ({
  sortedTableHeaders,
  onSortTableData,
  onSelectAll,
  isCheckboxSelected,
}) => {
  const [isChecked, setIsChecked] = useState(false);

  useEffect(() => {
    setIsChecked(isCheckboxSelected || false);
  }, [isCheckboxSelected]);

  return (
    <thead>
      <tr style={{ display: "flex", width: "100%" }}>
        {sortedTableHeaders.map((header, index) => (
          <td
            key={index}
            style={{
              width: `${header.width}%`,
            }}
          >
            <div
              className="header-details"
              onClick={
                header.key === "select" || header.type === "checkbox"
                  ? onSelectAll
                  : undefined
              }
            >
              <div className="header-details--text truncate">
                {header.key === "select" || header.type === "checkbox" ? (
                  <div className="header-details--checkbox flex items-center justify-center">
                    <CustomCheckBox
                      id={header.key}
                      label={""}
                      isChecked={isChecked}
                      onCheckBoxValueChange={() => setIsChecked(!isChecked)}
                      removeGap={true}
                    />
                  </div>
                ) : (
                  header.label
                )}
              </div>
              <div className="header-details--icon">
                {header.sortable && (
                  <SortArrow
                    onClick={() =>
                      onSortTableData(header.key, header.subKey, header.type)
                    }
                  />
                )}
              </div>
            </div>
          </td>
        ))}
      </tr>
    </thead>
  );
};

export default TableHeader;
